<template>
  <v-select
    :items="values"
    label="Pedido Gerente"
    item-text="text"
    item-value="value"
    v-model="valueSelecionado"
    chips
    multiple
  />
</template>

<script>
export default {
  name: 'FiltroPedidoGerente',
  data() {
    return {
      values: [
        {
          text: 'Não',
          value: 0
        },
        {
          text: 'Sim',
          value: 1
        },
        {
          text: 'Trazer somente pedidos feitos por gerente',
          value: 2
        },
        {
          text: 'Não interessados',
          value: 3
        }
      ],
      valueSelecionado: null
    }
  },
  watch: {
    valueSelecionado() {
      this.$emit('filtrar-pedido-gerente', {
        pedido_gerente: this.valueSelecionado
      })
    }
  }
}
</script>
